import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { Col } from '@amzn/stencil-react-components/layout'
import { H3, Text} from '@amzn/stencil-react-components/text'
import { Card, CardStatus } from '@amzn/stencil-react-components/card'
import { Link } from '@amzn/stencil-react-components/link'
import {MOCK_ID} from "../../../utils/testConstants";

class ArticleWithVideo extends Component {

    render() {

        const { t } = this.props;

        return(
            <Card dataTestId={MOCK_ID.ARTICLE_WITH_VIDEO} padding="0" maxWidth={480} status={CardStatus.Informational}>
                <Col dataTestId="Article_Video" width="100%">
                    <div style={{position: "relative", aspectRatio:"16/9"}}>
                        <iframe sandbox="allow-scripts allow-popups allow-presentation allow-same-origin"
                            height="100%"
                            width="100%"
                            style={{position:"absolute"}}
                            src={this.props.videoUrl}
                            allowFullScreen
                            title={this.props.title}
                        />
                    </div>
                    <Col padding="S500" gridGap="S200">
                        <Text dataTestId="Article_Title" fontWeight="medium">{this.props.title}</Text>
                        <Text dataTestId="Article_Description" >{this.props.description}</Text>
                        {this.props.haveAdditionalArticleDialog &&
                            <Link dataTestId="Read_More_Link" href="#" onClick={this.props.readMoreClickHandler}>
                              {t('HelpfulInformation.Article.ReadMore')}</Link>
                        }
                    </Col>
                </Col>
            </Card>
        );
    }
}

export default withTranslation('translationsV2')(ArticleWithVideo)
